import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { TOLL_LIQUIDATION_COLUMNS } from '../../../../config/columns';
import { TOLL_LIQUIDATION_PATH } from '../../../../config/paths';
import {
  clearTollLiquidations,
  getTollLiquidationExcel,
  getTollLiquidationAdditionalExcel,
  getTollLiquidations,
  getTollLiquidationProviaExcel,
  getTollLiquidationProviaDetailExcel,
  getTollLiquidationDetailExcel,
} from '../../../../actions/route/TollLiquidation';
import TollLiquidationsTollbar from './TollLiquidationsTollbar';
import { DEFAULT_QUERY } from '../../../../config/queries';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import TollLiquidationDownloadForm from './TollLiquidationDownloadForm';
import Table from '../../../common/Table';
import Content from '../../../layout/Content';

export const TollLiquidations = ({
  breadcrumbs,
  tollLiquidations,
  loading,
  dispatchGetTollLiquidations,
  dispatchClearTollLiquidations,
  dispatchGetTollLiquidationExcel,
  dispatchGetTollLiquidationAdditionalExcel,
  dispatchGetTollLiquidationProviaExcel,
  dispatchGetTollLiquidationProviaDetailExcel,
  dispatchGetTollLiquidationDetailExcel
}) => {
  useLayoutEffect(() => () => dispatchClearTollLiquidations(), []);

  const [query, setQuery] = useState('');

  const data = tollLiquidations.get('content') || [];
  const pages = tollLiquidations.get('totalPages') || null;
  const defaultPageSize = tollLiquidations.get('size') || DEFAULT_PAGE_SIZE;

  const toolBar = <TollLiquidationsTollbar />;

  const buildDownloadValues = (formValues) => {
    const from = tzNormalizeDate({
      date: formValues.fromDateString,
      format: INT_DATE_FORMAT,
    });

    const to = tzNormalizeDate({
      date: formValues.toDateString,
      format: INT_DATE_FORMAT,
    });

    return {
      ...DEFAULT_QUERY,
      size: DEFAULT_PAGE_SIZE,
      from,
      to,
    };
  };

  const onHandleSubmit = (formValues) => {
    const newFormValues = buildDownloadValues(formValues);

    setQuery(newFormValues);

    dispatchGetTollLiquidationExcel(newFormValues);
  };

  const onHandleSubmitAdditional = (formValues) => {
    const newFormValues = buildDownloadValues(formValues);

    setQuery(newFormValues);

    dispatchGetTollLiquidationAdditionalExcel(newFormValues);
  };

  const onHandleSubmitProvia = (formValues) => {
    const newFormValues = buildDownloadValues(formValues);

    setQuery(newFormValues);

    dispatchGetTollLiquidationProviaExcel(newFormValues);
  };

  const onHandleSubmitProviaDetail = (formValues) => {
    const newFormValues = buildDownloadValues(formValues);

    setQuery(newFormValues);

    dispatchGetTollLiquidationProviaDetailExcel(newFormValues);
  };

  const onHandleSubmitDetail = (formValues) => {
    const newFormValues = buildDownloadValues(formValues);

    setQuery(newFormValues);

    dispatchGetTollLiquidationDetailExcel(newFormValues);
  };

  const content = (
    <>
      <TollLiquidationDownloadForm
        onSubmit={onHandleSubmit}
        onDownloadAdditional={onHandleSubmitAdditional}
        onDownloadProvia={onHandleSubmitProvia}
        onDownloadProviaDetail={onHandleSubmitProviaDetail}
        onDownloadDetail={onHandleSubmitDetail}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
      />

      <h3>Liquidaciones de Peajes</h3>

      <Table
        columns={TOLL_LIQUIDATION_COLUMNS}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        fetchData={dispatchGetTollLiquidations}
        modelPath={TOLL_LIQUIDATION_PATH}
        loading={loading}
        filterable
        navigateToModelOnRowClick
        openPathInNewTab
        queryProps={query}
      />
    </>
  );

  return (
    <Content
      title="Liquidación de Peajes"
      breadcrumbs={breadcrumbs}
      toolbar={toolBar}
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTollLiquidations: getTollLiquidations,
  dispatchClearTollLiquidations: clearTollLiquidations,
  dispatchGetTollLiquidationExcel: getTollLiquidationExcel,
  dispatchGetTollLiquidationAdditionalExcel: getTollLiquidationAdditionalExcel,
  dispatchGetTollLiquidationProviaExcel: getTollLiquidationProviaExcel,
  dispatchGetTollLiquidationProviaDetailExcel: getTollLiquidationProviaDetailExcel,
  dispatchGetTollLiquidationDetailExcel: getTollLiquidationDetailExcel,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Liquidación de Peajes',
      href: TOLL_LIQUIDATION_PATH,
    },
  ],

  tollLiquidations: RouteUnit.TollLiquidation.getIn(['all', 'content']),

  loading: RouteUnit.TollLiquidation.getIn(['all', 'loading']),
});

TollLiquidations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  tollLiquidations: PropTypes.instanceOf(Immutable.Map),

  loading: PropTypes.bool,

  dispatchGetTollLiquidations: PropTypes.func.isRequired,

  dispatchClearTollLiquidations: PropTypes.func.isRequired,

  dispatchGetTollLiquidationExcel: PropTypes.func.isRequired,

  dispatchGetTollLiquidationAdditionalExcel: PropTypes.func.isRequired,
  dispatchGetTollLiquidationProviaExcel: PropTypes.func.isRequired,
  dispatchGetTollLiquidationProviaDetailExcel: PropTypes.func.isRequired,
  dispatchGetTollLiquidationDetailExcel: PropTypes.func.isRequired,
};

TollLiquidations.defaultProps = {
  tollLiquidations: Immutable.Map(),

  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(TollLiquidations);
